export const IconWarning = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.4642 8.05714C22.0357 5.31429 25.9643 5.31429 27.5358 8.05714L43.4469 35.8286C45.0184 38.5714 43.0541 42 39.9111 42H8.08888C4.94595 42 2.98161 38.5714 4.55308 35.8286L20.4642 8.05714Z"
      fill="#FFA600"
    />
    <path d="M24 17V27" stroke="white" strokeWidth="2" strokeLinecap="round" />
    <circle cx="24" cy="34.5" r="2.5" fill="white" />
  </svg>
)
